/* eslint-disable react/require-default-props */
import React from 'react';
import {View} from 'react-native';

import Button from '/component/base/Button';
import Icon from '/component/base/Icon';
import Text from '/component/base/Text';
import MetricSection from '/component/partial/MetricSection';
import metricSectionTestIDs from '/constant/TestIDs/MetricSection';
import {useTranslation} from '/provider/TranslationProvider';

import {styles} from './ShareCartSection.style';
import {
  generateShareCartInfoPress,
  generateViewSharedCartsPress,
} from './ShareCartSection.util';
interface ShareCartSectionProps {
  onShowInfoPopover?: () => void;
  onCreateCart?: () => void;
  onShareCart?: () => void;
  onEventData?: any;
}

export const ShareCartSection: React.FC<ShareCartSectionProps> = ({
  onShowInfoPopover,
  onCreateCart,
  onEventData,
}) => {
  const {ts} = useTranslation('component.partial.ShareCartSection');

  return (
    <>
      <MetricSection
        analyticsTitle="share_cart"
        infoAccessibilityLabel={ts(
          'accessibilityLabel',
          'Share Cart Section Information',
        )}
        title={ts('heading', 'Share Cart')}
        onInfoPress={generateShareCartInfoPress({onShowInfoPopover})}
        testID={metricSectionTestIDs.metricSectionShareCart}
        containerStyle={styles.metricSectionContainer}
        headerStyle={styles.metricSectionHeader}
      />
      <View style={styles.container}>
        <Text
          allowFontScaling
          maxFontSizeMultiplier={2}
          style={styles.description}>
          {ts(
            'description',
            'Share a predefined cart or create your cart to share with Clients.',
          )}
        </Text>
        <View style={styles.buttonContainer}>
          <Button
            type="primary"
            onPress={onCreateCart}
            style={styles.createButton}>
            {ts('createButton', 'Share Cart')}
          </Button>
          <Button
            type="secondary"
            onPress={generateViewSharedCartsPress(onEventData)}
            style={styles.shareButton}>
            <View style={styles.shareButtonContent}>
              <Text
                allowFontScaling
                maxFontSizeMultiplier={2}
                style={styles.shareButtonLabel}>
                {ts('shareButton', 'View Saved Carts')}
              </Text>
              <Icon name="logout" style={styles.shareIcon} />
            </View>
          </Button>
        </View>
      </View>
    </>
  );
};
